import apiService from './api';

class NotesApiService {
  // Create a new note
  async createNote(noteData) {
    return apiService.request('/notes', {
      method: 'POST',
      body: JSON.stringify(noteData)
    });
  }

  // Update a note (full update)
  async updateNote(noteId, noteData) {
    return apiService.request(`/notes/${noteId}`, {
      method: 'PUT',
      body: JSON.stringify(noteData)
    });
  }

  // Autosave a note (partial update)
  async autosaveNote(noteId, contentData) {
    return apiService.request(`/notes/${noteId}`, {
      method: 'PATCH',
      body: JSON.stringify(contentData)
    });
  }

  // Get my notes with filtering and pagination
  async getMyNotes(params = {}) {
    const queryParams = new URLSearchParams();
    
    if (params.courseId) queryParams.append('courseId', params.courseId);
    if (params.week) queryParams.append('week', params.week);
    if (params.search) queryParams.append('search', params.search);
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.page) queryParams.append('page', params.page);
    if (params.pageSize) queryParams.append('pageSize', params.pageSize);

    const queryString = queryParams.toString();
    const url = queryString ? `/notes/mine?${queryString}` : '/notes/mine';
    
    return apiService.request(url);
  }

  // Get a single note
  async getNote(noteId) {
    return apiService.request(`/notes/${noteId}`);
  }

  // Delete a note
  async deleteNote(noteId) {
    return apiService.request(`/notes/${noteId}`, {
      method: 'DELETE'
    });
  }

  // Pin a note
  async pinNote(noteId) {
    return apiService.request(`/notes/${noteId}/pin`, {
      method: 'POST'
    });
  }

  // Unpin a note
  async unpinNote(noteId) {
    return apiService.request(`/notes/${noteId}/unpin`, {
      method: 'POST'
    });
  }

  // Get courses for dropdown (helper method)
  async getCourses() {
    return apiService.request('/courses');
  }

  async getCourseSessions(courseId) {
    return apiService.getAttendanceSessions(courseId);
  }
}

const notesApiService = new NotesApiService();
export default notesApiService;
